import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import config from '../../config/index';
import AnalyticsUtil from '../../utils/AnalyticsUtil';
import MoveMoneyPayeeStore from '../../stores/MoveMoneyPayeeStore';
import MoveMoneyPayeeActionCreator from '../../actions/MoveMoneyPayeeActionCreator';
import LoaderComponent from '../common/LoaderComponent';
import AddCompanySummary from './AddCompanySummary';
import PatternLibModalComponent from '../common/modals/PatternLibModalComponent';
import NumberUtils from '../../utils/NumberUtils';
import StepHeader from '../../includes/StepHeader';
import { focusOnFirstComponent } from '../common/focusOnFirstComponent';

let theirReference = false;
let theirNickname = false;
let theirAccountName = false;
let rFlag = false;
let nFlag = false;
let anFlag = false;
let doErrorExist = false;
const addCompanyObj = {
  single_use: false,
  display_name: '',
  biller_id: '',
  company_name: '',
  reference: '',
};

class ReviewCompany extends Component {
  constructor(props) {
    super(props);
    this.showAddCompanyPerson = this.showAddCompanyPerson.bind(this);
    this.onChange = this.onChange.bind(this);
    this.getValidCompanyName = this.getValidCompanyName.bind(this);
    this.updateValueState = this.updateValueState.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.checkError = this.checkError.bind(this);
    this.goBackToSearchCompany = this.goBackToSearchCompany.bind(this);
    this.addPayeeConfirm = this.addPayeeConfirm.bind(this);
    this.onStoreChange = this.onStoreChange.bind(this);
    this.goToMoveMoneyPage = this.goToMoveMoneyPage.bind(this);
    this.closeErrorModal = this.closeErrorModal.bind(this);
    this.goToManagePayees = this.goToManagePayees.bind(this);
    this.handleRadioClick = this.handleRadioClick.bind(this);
    this.updateStore = this.updateStore.bind(this);
    this.getSortCodeDisplayNumber = this.getSortCodeDisplayNumber.bind(this);
    this.isValidAddCompanyResponse = this.isValidAddCompanyResponse.bind(this);
    this.getErrorMessage = this.getErrorMessage.bind(this);
    this.state = {
      isNicknameEnable: props.isEditCompanyFromCOP
        ? !MoveMoneyPayeeStore.getCompanyDetails().single_use
        : true,
      display_name:
        props.isEditCompanyFromCOP || props.isAddCompanyFromCOP
          ? MoveMoneyPayeeStore.getCompanyDetails().display_name
          : MoveMoneyPayeeStore.nameUpdate().display_name,
      reference:
        props.isEditCompanyFromCOP || props.isAddCompanyFromCOP
          ? MoveMoneyPayeeStore.getCompanyDetails().reference
          : '',
      errorPopup:
        props.isAddCompanyFromCOP && !this.isValidAddCompanyResponse()
          ? true
          : false,
      showPayeeSummaryPage:
        props.isAddCompanyFromCOP && this.isValidAddCompanyResponse()
          ? true
          : false,
      addCompanyFlag:
        props.isAddCompanyFromCOP && this.isValidAddCompanyResponse()
          ? false
          : true,
      errormessage:
        props.isAddCompanyFromCOP && !this.isValidAddCompanyResponse()
          ? this.getErrorMessage(props)
          : '',
      showLoaderSummary: false,
      account_name:
        props.isEditCompanyFromCOP || props.isAddCompanyFromCOP
          ? MoveMoneyPayeeStore.getCompanyDetails().name
          : '',
      summaryDetails:
        props.isAddCompanyFromCOP && this.isValidAddCompanyResponse()
          ? MoveMoneyPayeeStore.getAddCompanyPayeeResponse()
          : [],
      fieldBlurred: {
        reference: false,
        display_name: false,
      },
      fieldValid: {
        reference: true,
        display_name: true,
      },
    };
  }

  componentWillMount() {
    MoveMoneyPayeeStore.addChangeListener(this.onStoreChange);
    if (this.props.companyData.hint) {
      MoveMoneyPayeeStore.setBillerReferenceDescription(
        this.props.companyData.hint
      );
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    AnalyticsUtil.analyticAction(
      config.analytics.analytics_experience_view,
      config.analytics.analytics_event_method_appeared,
      'PageLoaded'
    );
    if (this.refs.accessH1ID) {
      focusOnFirstComponent(this.refs.accessH1ID);
    }
  }

  onBlur(e) {
    let parent;
    switch (e.target.name) {
      case 'reference':
        theirReference = true;
        const refValue = String(e.target.value.trim());
        const refRes = refValue.match(/^[0-9A-Za-z&./ ]{0,18}/);
        const refData = refRes[0].replace(/\s\s+/g, ' ');
        parent =
          e.currentTarget.attributes.getNamedItem('data-parent').textContent;
        this.checkError(e.target.name, refData, parent);
        this.updateValueState(e.target.name, refData);
        break;
      // TODO : Need to refactor this whole file to use textbox from web-ui-components
      // For now keeping it in same format as before for account name field
      case 'account_name':
        theirAccountName = true;
        let accNameRes = String(e.target.value).match(
          /^[0-9A-Za-z&()\\._/ -]{0,138}/
        );
        let accNameData = accNameRes[0].replace(/\s\s+/g, ' ');
        if (accNameData.length > 0 && accNameData.charAt(0) === ' ') {
          accNameData = accNameData.trim();
        }
        parent =
          e.currentTarget.attributes.getNamedItem('data-parent').textContent;
        this.updateValueState(e.target.name, accNameData);
        this.checkError(e.target.name, accNameData, parent);
        break;
      case 'display_name':
        theirNickname = true;
        const nicknameValue = String(e.target.value);
        const nicknameRes = nicknameValue.match(/^[0-9A-Za-z&()._/ -]{0,50}/);
        const nicknameData = nicknameRes[0].replace(/\s\s+/g, ' ');
        parent =
          e.currentTarget.attributes.getNamedItem('data-parent').textContent;
        this.checkError(e.target.name, nicknameData, parent);
        this.updateValueState(e.target.name, nicknameData);
        break;
    }
  }

  onChange(e) {
    // Getting the name and Value of input changed
    let parent;
    switch (e.target.name) {
      case 'reference':
        const refRes = String(e.target.value).match(/^[0-9A-Za-z&./ ]{0,18}/);
        let refData = refRes[0].replace(/\s\s+/g, ' ');
        if (refData.length > 0 && refData.charAt(0) === ' ') {
          refData = refData.trim();
        }
        this.updateValueState(e.target.name, refData);

        if (theirReference) {
          // theirref is kept to check for the first time
          parent =
            e.currentTarget.attributes.getNamedItem('data-parent').textContent;
          this.checkError(e.target.name, refData, parent);
        }

        break;
      case 'account_name':
        let accNameRes = String(e.target.value).match(
          /^[0-9A-Za-z&()\\._/ -]{0,138}/
        );
        let accNameData = accNameRes[0].replace(/\s\s+/g, ' ');
        if (accNameData.length > 0 && accNameData.charAt(0) === ' ') {
          accNameData = accNameData.trim();
        }
        this.updateValueState(e.target.name, accNameData);
        if (theirAccountName) {
          parent =
            e.currentTarget.attributes.getNamedItem('data-parent').textContent;
          this.checkError(e.target.name, accNameData, parent);
        }
        break;
      case 'display_name':
        let nicknameRes = String(e.target.value).match(
          /^[0-9A-Za-z&()._/ -]{0,50}/
        );
        const nicknameData = nicknameRes[0].replace(/\s\s+/g, ' ');
        this.updateValueState(e.target.name, nicknameData);

        if (theirNickname) {
          parent =
            e.currentTarget.attributes.getNamedItem('data-parent').textContent;
          this.checkError(e.target.name, nicknameData, parent);
        }
        break;
    }
  }

  onStoreChange() {
    const response = MoveMoneyPayeeStore.getAddCompanyPayeeResponse();
    if (response.code === 201) {
      this.setState({
        showPayeeSummaryPage: true,
        summaryDetails: response,
        showLoaderSummary: false,
      });
    } else if (response.code === 422) {
      this.setState({
        errorPopup: true,
        errormessage:
          response.error !== undefined
            ? response.error.message
            : this.props.content.duplicatePayeeErrrmsg,
        addCompanyFlag: true,
        showLoaderSummary: false,
      });
    }
  }

  getSortCodeDisplayNumber() {
    let sortcode = _.split(this.props.companyData.sort_code, '-');
    sortcode = NumberUtils.formatSortCode(sortcode[0]);
    return sortcode;
  }

  addPayeeConfirm() {
    this.props.setNickNameStatus(this.state.isNicknameEnable);
    if (this.refs.Reference.value === '') {
      this.refs['refErr'].className += ' c-field--error';
      this.refs['reference'].innerHTML =
        this.props.content.referenceErrorMessage;
      rFlag = true;
    } else {
      this.refs['refErr'].className = 'c-field';
      this.refs['reference'].innerHTML = '';
      rFlag = false;
    }

    if (MoveMoneyPayeeStore.getCopCheckNeeded()) {
      if (!this.refs.AccountName.value) {
        this.refs['accNameErr'].className += ' c-field--error';
        this.refs['account_name'].innerHTML =
          this.props.content.accountHolderErrorMessage;
        anFlag = true;
      } else {
        this.refs['accNameErr'].className = 'c-field';
        this.refs['account_name'].innerHTML = '';
        anFlag = false;
      }
    } else {
      anFlag = false;
    }

    if (this.state.isNicknameEnable) {
      if (this.refs.nick.value === '') {
        this.refs['nicknameErr'].className += ' c-field--error';
        this.refs['display_name'].innerHTML =
          this.props.content.nicknameErrorMessage;
        nFlag = true;
      } else {
        this.refs['nicknameErr'].className = 'c-field';
        this.refs['display_name'].innerHTML = '';
        nFlag = false;
      }
    } else {
      nFlag = false;
    }

    doErrorExist = true;
    if (rFlag) {
      this.refs.Reference.focus();
      window.scrollTo(0, 0);
    } else if (nFlag) {
      this.refs.nick.focus();
    } else if (anFlag) {
      this.refs.AccountName.focus();
    } else {
      doErrorExist = false;
    }
    if (!doErrorExist) {
      this.setState({
        addCompanyFlag: false,
        errorPopup: false,
        showLoaderSummary: true,
      });
      this.updateStore();

      let selectedCompanyRef = {};
      selectedCompanyRef.account_number = this.props.companyData.account_number;
      selectedCompanyRef.sort_code = this.props.companyData.sort_code;
      if (this.props.isEditCompanyFromCOP || this.props.isAddCompanyFromCOP) {
        selectedCompanyRef.company_name = this.props.companyData.company_name;
      } else {
        selectedCompanyRef.company_name = this.props.companyData.display_name;
      }
      selectedCompanyRef.biller_id = this.props.companyData.biller_id;
      selectedCompanyRef.single_use = !this.state.isNicknameEnable;
      selectedCompanyRef.name = this.state.account_name;
      selectedCompanyRef.reference = this.state.reference;
      selectedCompanyRef.display_name = this.state.display_name;
      MoveMoneyPayeeStore.setCompanyObject(selectedCompanyRef);
      if (MoveMoneyPayeeStore.getCopCheckNeeded()) {
        const formData = {
          account_number: this.props.companyData.account_number,
          display_name: this.props.companyData.display_name,
          name: this.state.account_name,
          reference: this.state.reference,
          single_use: !this.state.isNicknameEnable,
          sort_code: this.props.companyData.sort_code,
        };
        this.props.showCopComponent(formData);
      } else {
        MoveMoneyPayeeActionCreator.addCompanyPayee();
      }
      AnalyticsUtil.analyticAction(
        config.analytics.analytics_experience_activity,
        config.analytics.analytics_event_method_interacted,
        config.analytics.analytics_name_add_payee,
        'click'
      );
    }
  }

  checkError(fieldname, fieldAmount, parent) {
    switch (fieldname) {
      case 'reference':
        if (fieldAmount === '') {
          this.refs[parent].className += ' c-field--error';
          this.refs[fieldname].innerHTML =
            this.props.content.referenceErrorMessage;
          return true;
        } else {
          this.refs[parent].className = 'c-field';
          this.refs[fieldname].innerHTML = '';
          return false;
        }
        break;
      case 'account_name':
        if (fieldAmount === '') {
          this.refs[parent].className += ' c-field--error';
          this.refs[fieldname].innerHTML =
            this.props.content.accountHolderErrorMessage;
          return true;
        } else {
          this.refs[parent].className = 'c-field';
          this.refs[fieldname].innerHTML = '';
          return false;
        }
        break;
      case 'display_name':
        if (fieldAmount === '') {
          this.refs[parent].className += ' c-field--error';
          this.refs[fieldname].innerHTML =
            this.props.content.nicknameErrorMessage;
          return true;
        } else {
          this.refs[parent].className = 'c-field';
          this.refs[fieldname].innerHTML = '';
          return false;
        }
        break;
    }
  }

  closeErrorModal() {
    this.setState({ errorPopup: false });
  }

  goBackToSearchCompany() {
    this.props.updateIsEditCompanyFromCOP();
    MoveMoneyPayeeStore.setCompanyObject({});
    this.props.goBackToSearchCompany();
    // MoveMoneyPayeeStore.resetStore(); //WHY we need to reset here - BINOD
  }

  goToManagePayees() {
    this.props.goToManagePayees();
  }

  goToMoveMoneyPage() {
    this.props.goToMoveMoneyPage();
  }

  // To handle radio button click event
  handleRadioClick() {
    if (this.state.isNicknameEnable) {
      this.setState({
        isNicknameEnable: false,
        display_name: '',
        nFlag: false,
      });
      addCompanyObj.display_name = '';
    } else {
      this.setState({ isNicknameEnable: true });
    }
  }

  showAddCompanyPerson() {
    return (
      <div>
        <div className="c-field" ref="refErr">
          <label
            className="c-field__label c-field__label--block"
            htmlFor="reference"
          >
            {this.props.content.reference}
            <div className="c-field__instructions">
              {MoveMoneyPayeeStore.getBillerReferenceDescription()}
            </div>
          </label>
          <div className="c-field__controls">
            <input
              className="c-field__input"
              onBlur={this.onBlur}
              data-parent="refErr"
              type="text"
              name={this.props.content.payeeRequestPacket_reference}
              id="reference"
              onChange={this.onChange}
              value={this.state.reference}
              maxLength="18"
              size="18"
              ref="Reference"
              aria-required="true"
              aria-live="referenceErr"
              aria-invalid="false"
            />
            <div
              className="c-field__message"
              ref="reference"
              role="alert"
              id="referenceErr"
            />
          </div>
        </div>
        {MoveMoneyPayeeStore.getCopCheckNeeded() && (
          <div className="c-field" ref="accNameErr">
            <label
              className="c-field__label c-field__label--block"
              htmlFor="accountName"
            >
              {this.props.content.accountHolderName}
              <div className="c-field__instructions">
                {this.props.content.accountNameHintText}
              </div>
            </label>
            <div className="c-field__controls">
              <input
                className="c-field__input"
                onBlur={this.onBlur}
                data-parent="accNameErr"
                type="text"
                name={this.props.content.payeeRequestPacket_account_name}
                id="accountName"
                onChange={this.onChange}
                value={this.state.account_name}
                maxLength="138"
                size="138"
                ref="AccountName"
                aria-required="true"
                aria-live="AccountNameErr"
                aria-invalid="false"
              />
              <div
                className="c-field__message"
                ref="account_name"
                role="alert"
                id="AccountNameErr"
              />
            </div>
          </div>
        )}
        <div className="c-field c-field--checkbox">
          <label className="c-field__label">
            <input
              aria-label={this.props.content.addPayeeCheckboxText1}
              className="c-field__input"
              type="checkbox"
              defaultChecked={this.state.isNicknameEnable}
              onChange={this.handleRadioClick}
            />
            <span>{this.props.content.addPayeeCheckboxText1}</span>
            <div className="c-field__extra">
              {this.props.content.addPayeeCheckboxText2}
            </div>
          </label>
        </div>
        {this.state.isNicknameEnable ? (
          <div className="c-field" ref="nicknameErr">
            <label
              className="c-field__label c-field__label--block"
              htmlFor="nickName"
            >
              {this.props.content.addPayeeNickName}
              <div className="c-field__instructions">
                {this.props.content.nicknameHintText}
              </div>
            </label>
            <div className="c-field__controls">
              <input
                className="c-field__input"
                type="text"
                data-parent="nicknameErr"
                name={this.props.content.payeeRequestPacket_nick_name}
                id="nickName"
                onBlur={this.onBlur}
                onChange={this.onChange}
                value={this.state.display_name}
                ref="nick"
                maxLength="50"
                size="50"
                aria-required="true"
                aria-live="nicknameErrMsg"
                aria-invalid="false"
              />
              <div
                className="c-field__message"
                ref="display_name"
                role="alert"
                id="nicknameErrMsg"
              />
            </div>
          </div>
        ) : (
          ''
        )}
      </div>
    );
  }

  updateStore() {
    addCompanyObj.biller_id = this.props.companyData.biller_id;
    if (this.props.isEditCompanyFromCOP || this.props.isAddCompanyFromCOP) {
      addCompanyObj.company_name = this.props.companyData.company_name;
    } else {
      addCompanyObj.company_name = this.props.companyData.display_name;
    }
    addCompanyObj.single_use = !this.state.isNicknameEnable;
    addCompanyObj.reference = this.state.reference;
    addCompanyObj.display_name = this.state.display_name;
    MoveMoneyPayeeActionCreator.updateCompanyForm(addCompanyObj);
  }

  updateValueState(name, value) {
    this.setState({
      [name]: value,
    });
  }

  // Helper function to check the successful response from AddCompany service
  isValidAddCompanyResponse() {
    const response = MoveMoneyPayeeStore.getAddCompanyPayeeResponse();
    return response.code === 201;
  }
  getValidCompanyName() {
    return this.props.isEditCompanyFromCOP || this.props.isAddCompanyFromCOP
      ? this.props.companyData.company_name
      : this.props.companyData.display_name;
  }
  getErrorMessage(props) {
    const response = MoveMoneyPayeeStore.getAddCompanyPayeeResponse();
    if (response.error === undefined) {
      return this.props.content.duplicatePayeeErrrmsg;
    }
    return response.error.message;
  }

  render() {
    let renderContent;
    let footerButtons = (
      <div>
        <button
          className="c-btn c-btn--default c-modal__button"
          onClick={this.closeErrorModal}
        >
          OK
        </button>
      </div>
    );
    let modalbody = <p>{this.state.errormessage}</p>;
    if (this.state.addCompanyFlag) {
      renderContent = (
        <div>
          {' '}
          {/* Additional wrapper div added to avoid two hits of tab to get focus on 'Back' */}
          <span
            id="accessH1ID"
            tabIndex="0"
            className="u-visually-hidden off-screen"
            ref="accessH1ID"
          >
            You are on {this.props.content.payeeHeader} review and complete
          </span>
          <div role="main" id="site-main" tabIndex="-1">
            <StepHeader
              showheaderCrumbs="true"
              onClick={this.goBackToSearchCompany}
              headerCrumbsMessage={this.props.content.back}
              headerTitle={this.props.content.payeeHeader}
              headerSubtitle="Review and complete"
            />
            <dl className="c-definitions">
              <dt className="c-definitions__key">Name</dt>
              <dd className="c-definitions__value" ref="Company_Name">
                {this.getValidCompanyName()}
              </dd>

              <dt className="c-definitions__key">Sort code</dt>
              <dd className="c-definitions__value">
                {this.getSortCodeDisplayNumber()}
              </dd>

              <dt className="c-definitions__key">Account number</dt>
              <dd className="c-definitions__value">
                {this.props.companyData.account_number}
              </dd>
            </dl>

            <div className="add-edit-payee__form">
              {this.showAddCompanyPerson()}
              <div className="add-edit-payee__form__options">
                <button
                  type="button"
                  className="c-btn c-btn--secondary"
                  onTouchStart={this.goBackToSearchCompany}
                  onMouseDown={this.goBackToSearchCompany}
                >
                  Back
                </button>
                <button
                  type="button"
                  className="c-btn c-btn--default"
                  onClick={this.addPayeeConfirm}
                >
                  Continue
                </button>
              </div>
            </div>
            {this.state.errorPopup
              ? (renderContent = (
                  <PatternLibModalComponent
                    show={this.state.errorPopup}
                    customClass={'c-modal'}
                    onHide={() => this.closeErrorModal()}
                    bsSize={'medium'}
                    modalHeading={''}
                    modalBody={modalbody}
                    modalFooter={footerButtons}
                    modalInContainer={false}
                    closeButton
                  />
                ))
              : ''}
          </div>
        </div>
      );
    } else if (this.state.showPayeeSummaryPage) {
      renderContent = (
        <AddCompanySummary
          content={this.props.content}
          companyData={this.props.companyData}
          goToMoveMoneyPage={this.goToMoveMoneyPage}
          summaryDetails={this.state.summaryDetails}
          goToManagePayees={this.goToManagePayees}
          getValidCompanyName={this.getValidCompanyName}
        />
      );
    } else if (this.state.showLoaderSummary) {
      renderContent = <LoaderComponent type="large" />;
    }
    return <div>{renderContent}</div>;
  }
}

ReviewCompany.propTypes = {
  content: PropTypes.object,
  companyData: PropTypes.object,
  goBackToSearchCompany: PropTypes.func,
  goToMoveMoneyPage: PropTypes.func,
  goToManagePayees: PropTypes.func,
};
ReviewCompany.defaultProps = {
  content: {},
  companyData: {},
};
export default ReviewCompany;
